<template lang="html">
  <transition name="pop">
    <div
      v-if="visible"
      :style="{backgroundColor, backgroundImage, color: textColor === 'light' ? 'white' : 'black'}"
      class="interaction-hint"
    >
      <span>Swipe to rip off</span>
      <div
        :style="{borderColor: textColor === 'light' ? 'white' : 'black'}"
        class="hint"
      />
    </div>
  </transition>
</template>

<script>
import anime from 'animejs';

export default {
  props: {
    backgroundColor: {
      type: String,
      default: '#fff',
    },
    backgroundImage: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: 'light',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        window.setTimeout(() => anime({
          targets: '.hint',
          loop: true,
          width: [
            {
              value: el => `${el.parentElement.offsetWidth - 8}px`, duration: 500, delay: 500, easing: 'easeOutCubic',
            },
            { value: '32px', duration: 500, elasticity: 2 },
          ],
          translateX: [
            {
              value: 0, duration: 500, elasticity: 2, delay: 500,
            },
            { value: el => `${el.parentElement.offsetWidth - 32 - 8}px`, duration: 500, elasticity: 2 },
          ],
          opacity: [
            { value: 0.5, duration: 500, elasticity: 0 },
            {
              value: 0, duration: 500, delay: 1000, elasticity: 0,
            },
          ],
        }), 200);
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
.interaction-hint
  border-radius: 20px
  height: 40px
  box-shadow: 0 0 8px rgba(0,0,0,0.1), 0 8px 32px rgba(0,0,0,0.2)
  opacity: 0.9
  position: fixed
  bottom: 176px
  left: 0
  right: 0
  margin: auto
  width: 80%
  max-width: 320px
  z-index: 2
  pointer-events: none
  font-family: 'Montserrat', sans-serif
  text-transform: uppercase
  letter-spacing: 1px
  font-size: 0.8rem
  padding: 4px
  box-sizing: border-box
  text-align: center
  line-height: 32px
  overflow: hidden

  &.pop-enter-active,
  &.pop-leave-active
    transition: opacity 200ms ease-out

  &.pop-enter,
  &.pop-leave-to
    opacity: 0

  span
    opacity: 0.8

  .hint
    border: 2px solid black
    width: 32px
    height: @width
    box-sizing: border-box
    border-radius: 16px
    line-height: 30px
    opacity: 0
    overflow: hidden
    position: absolute
    top: 4px

</style>
